import { Link } from 'react-router-dom';
import { CHARACTER } from '@/constants/testIds';
import { MapPin } from 'lucide-react';

export default function CharacterCard({ character }) {
  const isMajor = character.importance === 'Major';
  const isOT = character.testament === 'Old';

  return (
    <Link
      to={`/character/${character.id}`}
      data-testid={CHARACTER.card}
      className="character-card"
    >
      <div className="flex items-start justify-between gap-3">
        <h3
          data-testid={CHARACTER.name}
          className="font-serif-display text-2xl text-slate-900 leading-tight"
        >
          {character.name}
        </h3>
        <div className="flex flex-col items-end gap-1">
          <span
            data-testid={CHARACTER.importanceTag}
            className={`tag-base ${
              isMajor
                ? 'bg-[#DBEAFE] text-[#1E3A8A]'
                : 'bg-slate-100 text-slate-600'
            }`}
          >
            {character.importance}
          </span>
        </div>
      </div>

      <div className="flex items-center gap-1.5 text-xs text-slate-500">
        <MapPin className="w-3 h-3" strokeWidth={2} />
        <span className="font-mono">{character.scripture_reference}</span>
      </div>

      <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">
        {character.details}
      </p>

      <div className="flex items-center gap-2 mt-auto pt-2 border-t border-slate-100">
        <span
          data-testid={CHARACTER.testamentTag}
          className={`tag-base ${
            isOT ? 'bg-amber-50 text-amber-700' : 'bg-[#CCFBF1] text-[#0F766E]'
          }`}
        >
          {isOT ? 'Old Testament' : 'New Testament'}
        </span>
        <span className="text-xs text-slate-400">·</span>
        <span className="text-xs text-slate-500">{character.book}</span>
      </div>
    </Link>
  );
}
